<template>
  <div v-if="loading == false">
    <h4 class="text-center">Pesquisar usuários</h4>

    <img
      src="@/assets/images/search.png"
      alt="search"
      class="d-none d-lg-block w-100 mb-5"
    />

    <div class="form-group row mb-1">
      <div class="col-lg-3 mb-1 mb-lg-0">
        <label>Id</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="user_filters.id"
        />
      </div>
      <div class="col-lg-9 mb-1 mb-lg-0">
        <label>Nome</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="user_filters.name"
        />
      </div>
    </div>

    <div class="form-group mb-1">
      <label>Perfil</label>
      <Dropdown
        ref="user_profile_dropdown"
        v-model="user_profile_filters.name"
        :editable="true"
        :options="filtered_user_profiles"
        option-label="name"
        option-value="name"
        class="w-100"
        @change="onUserProfileChange"
        @input="onUserProfileInput"
      />
    </div>

    <div class="form-group row mb-1">
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>RG</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="user_filters.rg"
        />
      </div>
      <div class="col-lg-6 mb-1 mb-lg-0">
        <label>CPF</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="user_filters.cpf"
        />
      </div>
    </div>

    <div class="form-group mb-3">
      <label>E-mail</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="user_filters.email"
      />
    </div>

    <div
      class="
        d-flex
        flex-column flex-lg-row
        align-items-center
        Isjustify-content-start
        justify-content-lg-between
      "
    >
      <button class="btn btn-success mb-3 mb-lg-0" @click="onFilter">
        <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon>
        Filtrar
      </button>

      <button class="btn btn-secondary" @click="clearFilter">
        <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
        Resetar
      </button>
    </div>
  </div>
</template>

<script>
  import { onBeforeMount, onMounted, ref } from 'vue'

  import Dropdown from 'primevue/dropdown'

  import useUser from '@/modules/User.js'
  import useUserProfiles from '@/modules/UserProfile.js'

  export default {
    components: {
      Dropdown,
    },
    setup() {
      const loading = ref(true)
      const user_profile_dropdown = ref(null)

      const { filtered_user_profiles, user_profile_filters, listUserProfiles } =
        useUserProfiles()
      const { user_filters, listUsers } = useUser()

      const clearFilter = () => {
        user_filters.value = {}
        refreshList()
      }

      const onFilter = () => {
        refreshList()
      }

      const onUserProfileChange = (event) => {
        if (event.value == null) {
          listUserProfiles()
        }

        user_filters.value.user_profile_name = event.value
      }

      const onUserProfileInput = (event) => {
        user_profile_dropdown.value.show()

        user_filters.value.user_profile_name = event.value
      }

      const refreshList = () => {
        listUsers(1, 10)
      }

      onBeforeMount(() => {
        clearFilter()
      })

      onMounted(() => {
        listUserProfiles().then(() => {
          loading.value = false
        })
      })

      return {
        filtered_user_profiles,
        user_profile_filters,
        user_filters,
        user_profile_dropdown,
        loading,
        clearFilter,
        onFilter,
        onUserProfileChange,
        onUserProfileInput,
      }
    },
  }
</script>
